import { decodeToken, getAccessTokenOrCookie } from '@backrs_ui/common-ui';

const isUnifiedLoginDisabled = process.env.REACT_APP_DISABLE_UNIFIED_LOGIN === 'true';

export const getBackrsToken = (): string | null => {
  return getAccessTokenOrCookie('backrs_ui_token', isUnifiedLoginDisabled);
};

export const isGuestToken = (token: string | null): boolean => {
  if (!token) return false;

  try {
    const decoded = decodeToken(token) as { scope?: string };

    return decoded.scope === 'guest';
  } catch (error) {
    console.error('Failed to decode backrs token', error);

    return false;
  }
};

export const getGuestTokenIfPresent = (): string | null => {
  const token = getBackrsToken();

  return isGuestToken(token) ? token : null;
};

export const isGuestTokenExpired = (token: string | null): boolean => {
  if (!token) return false;

  try {
    const decoded = decodeToken(token) as { exp?: number };

    if (typeof decoded.exp !== 'number') return true;

    return decoded.exp <= Math.floor(Date.now() / 1000);
  } catch (error) {
    console.error('Failed to decode backrs token', error);

    return true;
  }
};
